import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { equals } from 'ramda';

import ReduxFormWrapper from 'containers/ReduxFormWrapper';
import { actions, MODULE_ACCESSOR } from 'store/newDocumentStore';

// Interval for sending the edit-queue to the server (in ms).
const QUEUE_DELAY = 175;

class EditableV2 extends Component {
  stagedChanges = null;
  timerRef;

  constructor(props) {
    super(props);

    this.saveStagedChanges = () => {
      const { dispatch, documentId, isLoading, editedCommit, moduleName } = this.props;
      if (this.stagedChanges !== null && !isLoading) {
        dispatch(actions.updateCommit(moduleName, documentId, editedCommit.commitId, this.stagedChanges));
        this.stagedChanges = null;
      }
      this.handleChangeBatching();
    };
  }

  handleChangeBatching() {
    clearTimeout(this.timerRef);
    this.timerRef = setTimeout(this.saveStagedChanges, QUEUE_DELAY);
  }

  finalizeChanges() {
    clearTimeout(this.timerRef);
  }

  componentDidMount() {
    this.handleChangeBatching();
  }

  componentWillReceiveProps(nextProps) {
    const { formValues } = this.props;
    const nextValues = nextProps.formValues;
    if (formValues && nextValues && !equals(formValues, nextValues)) {
      this.stagedChanges = nextValues;
    }
  }

  shouldComponentUpdate({ documentId: nextId, formValues: nextValues }) {
    const { documentId, formValues } = this.props;
    return documentId !== nextId || !equals(formValues, nextValues);
  }

  componentWillUnmount() {
    this.finalizeChanges();
  }

  render() {
    const { moduleName, children, formValues = {}, editedCommit, documentId, formSettings } = this.props;
    const initialValues = editedCommit.data || {};
    return createElement(
      ReduxFormWrapper,
      { form: moduleName, editing: true, formValues, initialValues, documentId, editedCommit, formSettings },
      children,
    );
  }
}

EditableV2.propTypes = {
  moduleName: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  documentId: PropTypes.string.isRequired,
  editedCommit: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  formValues: PropTypes.object,
  formSettings: PropTypes.object,
  dispatch: PropTypes.func,
};

const mapStateToProps = (state, { moduleName }) => ({
  isLoading: state.newDocs[MODULE_ACCESSOR][moduleName].isLoading,
  formSettings: state.settings?.ms?.app?.formSettings?.[moduleName] ?? {},
  formValues: getFormValues(moduleName)(state),
});

export default connect(mapStateToProps)(EditableV2);
